<template>
  <a-card :bordered="false">
    <div class="title">{{ ticketName }}( {{ erpTicketId }}) 详细信息</div>
    <a-table style="margin-top: 10px" :columns="columns" rowKey="erpTicketId" :data-source="productList"
             :pagination="false">
      <template slot="latSlots" slot-scope="text, record">
        <div>经:{{ record.longitude }}</div>
        <div>纬:{{ record.latitude }}</div>
      </template>
    </a-table>
    <div style="display: flex;justify-content: space-between;margin-top: 20px;align-items: center">
      <div class="title">匹配到商品信息 <span
        class="notice">*注意：请仔细比对商品信息，如与上述基础数据不一致，请及时处理！</span></div>
      <a-button style="margin-right: 50px;" type="primary" @click="goManualMatch">重新匹配</a-button>
    </div>
    <a-table style="margin-top: 10px" :columns="matchColumns" rowKey="ticketId" :data-source="matchProductList"
             :pagination="false">
      <template slot="latSlots" slot-scope="text, record">
        <div>经:{{ record.longitude }}</div>
        <div>纬:{{ record.latitude }}</div>
      </template>
      <template slot="action" slot-scope="text, record">已匹配</template>
    </a-table>
    <div style="margin-top: 20px;" class="title">该产品共有{{ optionLength }}个票型</div>
    <a-table style="margin-top: 10px;width: 600px" :columns="columnsTicket" rowKey="optionId" :data-source="optionList"
             :pagination="false"></a-table>
    <a-button style="margin-top: 40px" @click="goBack">返回</a-button>
  </a-card>
</template>

<script>
export default {
  name: 'MatchDetails',
  data() {
    return {
      columns: [
        {
          title: '商品ID',
          dataIndex: 'erpTicketId'
        },
        {
          title: '商品名称',
          dataIndex: 'ticketName'
        },
        {
          title: '所在城市',
          dataIndex: 'cityName'
        },
        {
          title: '联系电话',
          dataIndex: 'hotelPhone'
        },
        {
          title: '地址',
          dataIndex: 'ticketAddress'
        },
        {
          title: '经纬度',
          scopedSlots: { customRender: 'latSlots' }
        },
        {
          title: '状态',
          dataIndex: 'ticketStatusStr'
        },
        {
          title: '匹配状态',
          dataIndex: 'matchStatusStr'
        }
      ],
      matchColumns: [
        {
          title: '商品ID',
          dataIndex: 'ticketId'
        },
        {
          title: '商品名称',
          dataIndex: 'ticketName'
        },
        {
          title: '所在城市',
          dataIndex: 'cityName'
        },
        {
          title: '联系电话',
          dataIndex: 'ticketPhone'
        },
        {
          title: '地址',
          dataIndex: 'ticketAddress'
        },
        {
          title: '经纬度',
          scopedSlots: { customRender: 'latSlots' }
        },
        {
          title: '状态',
          dataIndex: 'ticketStatusStr'
        },
        {
          title: '匹配状态',
          scopedSlots: { customRender: 'action' }
        }
      ],
      columnsTicket: [
        {
          title: '票型ID',
          dataIndex: 'optionId'
        },
        {
          title: '票型信息',
          dataIndex: 'optionName'
        },
        {
          title: '状态',
          dataIndex: 'optionStatusStr'
        }
      ],
      ticketName: this.$route.query.ticketName,
      erpTicketId: this.$route.query.erpTicketId,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      productList: [],
      matchProductList: [],
      optionList: [],
      optionLength: []
    }
  },
  mounted() {
    this.getDetailList()
  },
  methods: {
    goManualMatch() {
      let query = {
        serverId: this.$route.query.serverId,
        serverUniqueId: this.$route.query.serverUniqueId,
        erpTicketId: this.erpTicketId,
        ticketName: this.ticketName
      }
      this.openNewPage('ManualMatch', query)
    },
    getDetailList() {
      let params = {
        erpTicketId: this.erpTicketId,
        merchantId: this.merchantId,
        platformId: this.platformId,
        searchOption: true
      }
      this.getHttpServices().getCloudProService().post('erp/queryErpTicketMatchDetails', params)
        .then(res => {
          if (res.erpTicketInfo) {
            this.productList = [res.erpTicketInfo]
          }
          if (res.matchTicketInfo && res.matchTicketInfo.length > 0) {
            this.matchProductList = res.matchTicketInfo
            let arr = []
            res.matchTicketInfo.forEach(item => {
              if (item.matchTicketOptionList && item.matchTicketOptionList.length > 0) {
                this.getLogUtils().logWithTag('matchTicketOptionList', item.matchTicketOptionList)
                item.matchTicketOptionList.forEach(item2 => {
                  arr.push(item2)
                })
              }
            })
            this.optionList = arr
            this.optionLength = this.optionList.length
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
  line-height: 15px;
  font-weight: bold;
}

.notice {
  color: #ff6600;
  font-weight: 400;
}
</style>